import store from "../js/store/index";
import { addTodoItem } from "../js/actions/index";

window.store = store;
window.addTodoItem = addTodoItem;

